import React from "react";

import type { AdminLeaveStats } from "../../../../../../core/data/redux/admin-leaves/types";

interface AdminLeavesStatsProps {
  stats: AdminLeaveStats | null;
  loading: boolean;
}

interface StatCardProps {
  label: string;
  value: number;
  icon: string;
  iconClass: string;
  cardBg: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, icon, iconClass, cardBg }) => (
  <div className="col-xl-3 col-md-6">
    <div className={`card`}>
      <div className="card-body bg-white rounded-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-2">
              <span className="avatar avatar-lg rounded-circle bg-white d-flex align-items-center justify-content-center">
                <i className={`ti ${icon} ${iconClass} fs-28`} />
              </span>
            </div>
          </div>
          <div className="text-end">
            <p className="mb-1">{label}</p>
            <h4>{value}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const AdminLeavesStats: React.FC<AdminLeavesStatsProps> = ({ stats, loading }) => {
  if (loading && !stats) {
    return (
      <div className="row">
        {[0, 1, 2, 3].map((i) => (
          <div className="col-xl-3 col-md-6" key={i}>
            <div className="card">
              <div className="card-body bg-white rounded-3">
                <div className="placeholder-glow">
                  <div
                    className="placeholder col-6 mb-2"
                    style={{ height: 12, borderRadius: 4 }}
                  />
                  <div
                    className="placeholder col-3"
                    style={{ height: 24, borderRadius: 4 }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const safe = stats ?? {
    totalApplications: 0,
    planned: 0,
    unlimited: 0,
    pending: 0,
    approved: 0,
    rejected: 0,
    cancelled: 0,
  };

  return (
    <div className="row">
      <StatCard
        label="Total Applications"
        value={safe.totalApplications}
        icon="ti-user-check"
        iconClass="text-success"
        cardBg="bg-green-img"
      />
      <StatCard
        label="Planned Leaves"
        value={safe.planned}
        icon="ti-user-edit"
        iconClass="text-pink"
        cardBg="bg-pink-img"
      />
      <StatCard
        label="Unplanned Leaves"
        value={safe.unlimited}
        icon="ti-infinity"
        iconClass="text-warning"
        cardBg="bg-yellow-img"
      />
      <StatCard
        label="Pending Requests"
        value={safe.pending}
        icon="ti-user-question"
        iconClass="text-info"
        cardBg="bg-blue-img"
      />
    </div>
  );
};

export default AdminLeavesStats;
